import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../images/Logo.png';
import '../styles/template.css';
import Types from '../images/Types.JPG';
import AppStore from '../images/AppStore.png';
import PlayStore from '../images/play.png';
import Instagram from '../images/instagram.png';


const HomePage = () => {
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const image = new Image();
    image.src = Types;
    image.onload = handleImageLoaded;
  }, []);

  const handleImageLoaded = () => {
    setImageLoaded(true);
  };

  return (
    <div className="container">
      {!imageLoaded && (
        <div className="loading-screen">
          <img src={Logo} alt="Logo" className="loading-logo" />
        </div>
      )}

      <header>
        <div className="logo-container">
          <img src={Logo} alt="Logo" className="logo" />
        </div>
        <h1>Know Yourself</h1>
        <nav>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/partners">Partners</Link></li>
            <li><Link to="/connect">Meetups</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </nav>
      </header>

      <main>
        <h2 className="main-heading">Explore New Places That Match How You Think</h2>
        
        <div className="content-wrapper">
          <section className="types-section">
            <picture>
              <source media="(min-width: 768px)" srcSet={Types} />
              <source media="(max-width: 767px)" srcSet={Types} />
              <img src={Types} alt="Intelligence Types" className="types-image" />
            </picture>
          </section>

          <section className="description">
            <h3>Discover Your Perfect Destinations</h3>
            <p>
              Find amazing places across Los Angeles and beyond that fit your unique thinking style. We help you discover destinations that feel just right for you.
            </p>
            
            <h3>Connect with Like-Minded People</h3>
            <p>
              Meet people who share your interests and explore together. Build real connections with others who think like you do.
            </p>
            
            <h3>Your Experience</h3>
            <p>
              Explore your city and find hidden gems! Bookmark destinations that resonate with you. Receive recommendations tailored to your thinking style. Connect with like-minded explorers. Join community meetups coming soon.
            </p>
          </section>
        </div>

        <div className="app-store-container">
          <a href="https://apps.apple.com/us/app/know-yourself-self-discovery/id6504838908" target="_blank" rel="noopener noreferrer">
            <img src={AppStore} alt="Download on the App Store" className="app-store-image" />
          </a>
        </div>

        <div className="play-store-container">
          <a href="https://play.google.com/store/apps/details?id=com.grantreynolds.knowyourselfproject" target="_blank" rel="noopener noreferrer">
            <img src={PlayStore} alt="Get it on Google Play" className="play-store-image" />
          </a>
        </div>

        <div className="social-media-container">
          <p className="social-media-text">Follow us on social media @knowyourself_project</p>
          <div className="social-icons">
            <a href="https://www.instagram.com/knowyourself_project/" target="_blank" rel="noopener noreferrer">
              <img src={Instagram} alt="Follow us on Instagram @knowyourself_project" className="social-icon-large" />
            </a>
          </div>
        </div>
      </main>

      <footer>
        <p>&copy; 2026 Know Yourself LLC | All rights reserved.</p>
      </footer>
    </div>
  );
};

export default HomePage;
